import { render } from "./old-version-login.vue?vue&type=template&id=3b7df206"
import script from "./old-version-login.vue?vue&type=script&lang=js"
export * from "./old-version-login.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vistream-spa-cp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__